<template>
    <div
        class="rounded-lg border-2 border-background-accent-dark py-2 px-4 drop-shadow-md bg-background-accent"
        :class="{'px-8 py-4': large}"
    >
        <slot/>
    </div>
</template>

<script lang="ts" setup>
defineProps({
    large: {
        type: Boolean,
        required: false,
        default: false
    }
})
</script>
